module.exports = __webpack_public_path__ + "images/Dropbox-239ee9.png";